module.exports = __webpack_public_path__ + "img/button_down_dark.110a7106.png";